import React from "react";
import { motion } from "framer-motion";
import { Cable, Building2, DoorOpen, Sun, PlugZap, Siren, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Cable,
    id: "instalaciones",
    title: "Instalaciones eléctricas",
    subtitle: "Certificadas · Cumplimiento REBT",
    body: "Nuevas instalaciones y reformas completas de baja tensión con boletín eléctrico y certificado de instalador autorizado.",
    tag: "ITC-BT",
  },
  {
    icon: Building2,
    id: "comunidades",
    title: "Hoteles, apartamentos y comunidades",
    subtitle: "Mantenimiento integral",
    body: "Mi especialidad: contratos de mantenimiento eléctrico para hoteles, complejos de apartamentos y comunidades de vecinos. Cuadros generales, alumbrado de zonas comunes, garajes y telecomunicaciones.",
    tag: "Mantenimiento",
  },
  {
    icon: DoorOpen,
    id: "videoporteros",
    title: "Videoporteros",
    subtitle: "Instalación y reparación",
    body: "Videoporteros analógicos e IP, sustitución de terminales antiguos y conexión de nuevas viviendas al portero comunitario.",
    tag: "Fermax · Tegui",
  },
  {
    icon: Sun,
    id: "fotovoltaica",
    title: "Fotovoltaica y BT",
    subtitle: "Revisión y legalización",
    body: "Inspección y puesta a punto de instalaciones fotovoltaicas de autoconsumo y sus cuadros de baja tensión asociados.",
    tag: "Autoconsumo",
  },
  {
    icon: PlugZap,
    id: "recarga_ve",
    title: "Puntos de recarga VE",
    subtitle: "Coche eléctrico",
    body: "Instalación de cargadores para coche eléctrico en vivienda, comunidad o negocio, cumpliendo la ITC-BT-52.",
    tag: "ITC-BT-52",
  },
  {
    icon: Siren,
    id: "averias_urgentes",
    title: "Averías urgentes",
    subtitle: "Atención el mismo día",
    body: "Corte de luz, diferencial que salta, tomas quemadas, cortocircuitos. Localizo y reparo la avería con rapidez.",
    tag: "24-72h",
  },
];

export default function Services() {
  return (
    <section id="servicios" className="relative py-24 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="section-label mb-4">02 · Servicios</span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-white mt-4 max-w-3xl">
              Especialista en{" "}
              <span className="text-[#E57C23]">mantenimiento de hoteles, apartamentos y comunidades.</span>
            </h2>
          </div>
          <p className="text-[#9CA3AF] max-w-md text-[15px] leading-relaxed">
            Mi fuerte es el mantenimiento eléctrico continuo de hoteles,
            complejos de apartamentos y comunidades de vecinos — además de
            instalaciones, fotovoltaica y averías. Siempre el mismo técnico,
            con material certificado y sin subcontratas improvisadas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.a
                key={s.id}
                href="#contacto"
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="card-circuit p-7 group block"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="h-11 w-11 rounded-lg border border-white/10 bg-[#0A0D14] flex items-center justify-center card-icon text-white/80">
                    <Icon size={20} strokeWidth={1.8} />
                  </div>
                  <span className="font-mono text-[10px] tracking-[0.18em] text-white/40 border border-white/10 rounded-full px-2 py-1">
                    {s.tag}
                  </span>
                </div>

                <h3 className="font-display text-2xl text-white leading-tight">
                  {s.title}
                </h3>
                <div className="mt-1 text-[13px] font-mono text-[#00E5FF]/70 tracking-wide">
                  {s.subtitle}
                </div>
                <p className="mt-4 text-[14.5px] text-[#9CA3AF] leading-relaxed">
                  {s.body}
                </p>

                <div className="mt-6 flex items-center gap-1 text-sm text-white/70 group-hover:text-[#00E5FF] transition-colors">
                  Solicitar presupuesto
                  <ArrowUpRight
                    size={16}
                    className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
